module.exports = __webpack_public_path__ + "assets/img/redpacket-line-icon.32359c3e.png";